import { render, staticRenderFns } from "./dialogBox.vue?vue&type=template&id=ff6054e8&scoped=true"
import script from "./dialogBox.vue?vue&type=script&lang=js"
export * from "./dialogBox.vue?vue&type=script&lang=js"
import style0 from "./dialogBox.vue?vue&type=style&index=0&id=ff6054e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6054e8",
  null
  
)

export default component.exports